export default __webpack_public_path__ + "static/media/how-it-works-2k.7449b88c.mp4";